export default __webpack_public_path__ + "static/media/announcement.da63f4a0.jpg";